/// <reference path="./next-i18next.config.d.ts" />

const SUPPORTED_LOCALES = [
  "en-US",
  "de-DE",
  "es-ES",
  "fr-FR",
  "it-IT",
  "ja-JP",
  "ko-KR",
  "pt-BR",
  "zh-TW",
];

const i18nConfig = {
  locales: SUPPORTED_LOCALES,
  defaultLocale: "en-US",
  localeDetection: false,
  prefixDefault: false,
};

module.exports = i18nConfig;
